import { jsxs, jsx } from 'react/jsx-runtime';
import { getClassNames } from '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { motion } from 'framer-motion';
import { useLlm } from '../../../useLlm/useLlm.js';
import { useLlmView } from '../../../useLlm/useLlmView.js';
import { messageMapper } from '../../utils.js';
import { Canvas } from '../Canvas/canvas.js';

const Trigger = () => {
  var _a;
  const theme = useLlm(state => state.theme);
  const {
    Blob
  } = useLlm(state => state.components);
  const app = useLlm(state => state.app);
  const opened = useLlmView(state => state.opened);
  const {
    open
  } = useLlmView(state => state.actions);
  const label = useLabel();
  const collapsedWelcomeText = messageMapper(app === null || app === void 0 ? void 0 : app.contents.collapsedWelcomeText);
  const collapsedWelcomeTextCta = messageMapper(app === null || app === void 0 ? void 0 : app.contents.collapsedWelcomeTextCta);
  const collapsedWelcomeTextHover = messageMapper(app === null || app === void 0 ? void 0 : app.contents.collapsedWelcomeTextHover);
  const position = ((_a = theme.trigger) === null || _a === void 0 ? void 0 : _a.position) || 'bottom';
  return jsxs(motion.nav, {
    className: getClassNames('llm__trigger', '-' + position),
    initial: {
      y: '200%',
      opacity: 0
    },
    animate: {
      y: 0,
      opacity: 1
    },
    exit: {
      y: '200%',
      opacity: 0
    },
    transition: {
      duration: .4
    },
    "aria-label": "Trigger",
    /*
    aria-expanded={opened}
    aria-controls={mainId}
    */
    onClick: () => open(),
    children: [jsxs("button", {
      type: "button",
      className: getClassNames('llm__trigger-btn', {
        'llm__trigger-btn--hover': collapsedWelcomeTextHover !== undefined
      }),
      children: [jsx(Blob, {}), jsx("span", {
        children: label('llm.button')
      })]
    }), !opened && (collapsedWelcomeText || collapsedWelcomeTextCta || collapsedWelcomeTextHover) && jsxs("div", {
      className: "llm__trigger-popup -llm-t-body2",
      children: [(collapsedWelcomeText || collapsedWelcomeTextCta) && jsxs(motion.div, {
        className: "llm__trigger-message",
        exit: {
          opacity: 0
        },
        children: [jsx(Canvas, {}), collapsedWelcomeText, collapsedWelcomeTextCta && jsx("button", {
          type: "button",
          className: "llm__trigger-cta",
          children: collapsedWelcomeTextCta
        })]
      }), collapsedWelcomeTextHover && jsxs(motion.div, {
        className: "llm__trigger-message",
        exit: {
          opacity: 0
        },
        children: [jsx(Canvas, {}), collapsedWelcomeTextHover]
      })]
    })]
  });
};

export { Trigger };
//# sourceMappingURL=trigger.js.map
